$('.buscarExamenes').keyup(delay(function(e){

    // var pag = $('#pagina').val();
    // el parametro es la pagina. Cuando vienes del input siempre mostramos la pagina 1
    filtrarExamenesPorTexto(1);
    
}, 400));

function filtrarExamenesPorTexto(paginaRequerida){

    var textoExamenes = $('#search').val();  

    // esto nos dice en que pagina estamos para construir el enlace del boton
    var tipoEnlace = $('#tipo-url').val();
    var numRegistros = $('#_regxpag').val();
    var orden = $('#_orden').val();
    var pag = $('#pagina').val();

    if(textoExamenes.length == 0 && parseInt(pag) > 1){
        paginaRequerida = pag;
    }

    jQuery.ajax({
        type: 'POST',
        async: true,
        url: rutajs+'lib/ajax.php',
        data : 'fn=getExamenesPorTexto&sExamen='+htmlspecialchars(textoExamenes)+'&limit='+numRegistros+'&sTipoEnlace='+tipoEnlace+'&_orden='+orden+'&_pag='+paginaRequerida,
        success: function(data) {

            data = JSON.parse(data);
            // console.log(data.sql);
            // $('.sql').html(data.sql);
            $('.reg-async').html(data.examenes);
            $('.resultados').html(data.registros);
            $('.paginacion-dinamica').html(data.paginacion);

            if(parseInt(data.contador) < parseInt(numRegistros)) {
                $('.paginacion-dinamica').addClass('hide');
            } else {
                $('.paginacion-dinamica').removeClass('hide');
            }
            // $('.icon-container').addClass('hide');
        }
      });

}

function paginacionAsincrona(formulario, url, numPag, elemento, pagina){

    if(pagina == 'examenes'){
        
        filtrarExamenesPorTexto(numPag);

    } else if(pagina == 'convocatorias')  {

        borrarFiltroInputCheck(numPag);
    }

    goTo('id-altura-tabla');

}